import React, { useState,useRef, useEffect } from "react";
import "./LandingPage.css";
import { FaMapMarkedAlt, FaUserCheck, FaHandshake, FaCogs, FaSprayCan } from 'react-icons/fa';
import { FiHeadphones } from 'react-icons/fi';
import { FaCheck } from 'react-icons/fa';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import { FaBullseye, FaEye } from 'react-icons/fa';
import { FaBuilding, FaShieldAlt,FaMobileAlt, FaCalendarAlt, FaUsers, FaExchangeAlt, FaRegCalendarCheck, FaBolt, FaPlaneDeparture } from 'react-icons/fa';



const LandingPage = () => {

        const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
    const [startIndex, setStartIndex] = useState(0);
  const [cardsPerPage, setCardsPerPage] = useState(4);

  useEffect(() => {
  const isDesktop = window.innerWidth > 768;

  if (selectedCategory && isDesktop) {
    const element = document.getElementById('fle');
    if (element) {
      const yOffset = -250; // Adjust if needed
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}, [selectedCategory]);




  // Detect screen width and adjust testimonials per view
  useEffect(() => {
    const updateCardsPerPage = () => {
      if (window.innerWidth <= 640) setCardsPerPage(1);
      else if (window.innerWidth <= 1024) setCardsPerPage(2);
      else setCardsPerPage(4);
    };

    updateCardsPerPage();
    window.addEventListener("resize", updateCardsPerPage);
    return () => window.removeEventListener("resize", updateCardsPerPage);
  }, []);

  const [menuOpen, setMenuOpen] = useState(false);
  const sliderRef = useRef(null);

const scrollLeft = () => {
  if (sliderRef.current) {
    sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  }
};

const scrollRight = () => {
  if (sliderRef.current) {
    sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  }
};


  const toggleMobileMenu = () => setMenuOpen(!menuOpen);
  const detailsRef = useRef(null);
const [userName, setUserName] = useState("");
const [userLocation, setUserLocation] = useState("");
const testimonials = [
  { name: "Acme Corp", text: "OTONYX has streamlined our employee travel like never before. Reliable service, professional chauffeurs — highly recommended!", stars: 5 },
  { name: "Zenith Ltd", text: "Professionalism and punctuality — their fleet is always immaculate!", stars: 4 },
  { name: "Bright Solutions", text: "We’ve saved time and cost thanks to OTONYX's monthly rental plans.", stars: 5 },
  { name: "InnovateX", text: "24/7 support really makes our life easier, even for last-minute bookings.", stars: 5 },
  { name: "Bluewave", text: "Drivers are always courteous and cars clean — can’t ask for more.", stars: 4 },
  { name: "Alpha Systems", text: "Love the flexibility and ease of booking, great customer support!", stars: 5 },
];

  const handleViewMore = (service) => {
    setSelectedService(service);
    setTimeout(() => {
      detailsRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };
  const handlePrev = () => {
    setStartIndex((prev) =>
      (prev - cardsPerPage + testimonials.length) % testimonials.length
    );
  };

  const handleNext = () => {
    setStartIndex((prev) => (prev + cardsPerPage) % testimonials.length);
  };




const fleetCategories = [
  {
    category: "Intermediate",
    image: "/intermediate.jpeg",
    description: "Toyota Etios, Swift Dzire, Honda Amaze"
  },
  {
    category: "Standard",
    image: "/standard.jpeg",
    description: "Honda City, Suzuki Ciaz"
  },
  {
    category: "Multi Utility Vehicles (MUV)",
    image: "/muv.jpeg",
    description: "Toyota Innova Crysta, Innova Hycross, MG Hector"
  },
  {
    category: "Premium",
    image: "/preium.png",
    description: "Toyota Camry, Toyota Fortuner"
  },
  {
    category: "Super Premium",
    image: "upper-premium.jpeg",
    description: "Mercedes C Class, BMW 3 Series"
  },
  {
    category: "Luxury & Super Luxury",
    image: "/luxury.jpeg",
    description: "Mercedes E Class, BMW 5 Series, BMW 7 Series"
  },
  {
    category: "Luxury Vans",
    image: "/Vans.png",
    description: "Toyota Commuter, Toyota Vellfire"
  },
  {
    category: "Fleet for Group Travel",
    image: "/Van.jpeg",
    description: "Tata Force, SML Isuzu, Bharat Benz, Tempo Traveller, Urbania, 20–50 Seater Buses, Volvo Buses"
  }
];


   

  return (
    <div className="landing-container">
<div className="top-navbar">
  <div className="social-icons">
  <a href="https://www.instagram.com/otonyx_mobility?igsh=NnV6MTA2aDF6cmRv" target="_blank" rel="noopener noreferrer">
    <FaInstagram />
  </a>
  <a href="https://www.linkedin.com/in/joseph-philip-557914335?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer">
    <FaLinkedinIn />
  </a>
</div>
  <div className="contact-info">
    Call us: +91-8484 8797 25  | Email: info@otonyxindia.com
  </div>
</div>


<nav className="navbar">
  <div  className="logo">
    <a href="#">
    <img src="/Logo1.png" alt="Car Logo" />
    </a>
  </div>
  <ul className="nav-links">
    <li><a href="#about">About Us</a></li>
    <li><a href="#services">Services</a></li>
    <li><a href="#fleet">Fleet</a></li>
    <li><a href="#tech">Technology</a></li>
    <li><a href="#whychooseus">Why Choose Us</a></li>
    <li><a href="#testimonials">Testimonials</a></li>
  </ul>
 <a
  href="https://wa.me/918484879725?text=Hi%2C%20I%20would%20like%20to%20book%20a%20service%20with%OTONYX."
  target="_blank"
  rel="noopener noreferrer"
  className="btn"
>
  Book Now
</a>
</nav>
     <nav className="mobile-navbar">
        <div className="mobile-navbar-container">
          <div className="mobile-navbar-logo">
            <a href="#">
              <img src="/Logo1.png" alt="Car Logo" />
            </a>
          </div>

          <button className="mobile-navbar-hamburger" onClick={toggleMobileMenu}>
            {menuOpen ? "×" : "☰"}
          </button>

          <ul className={`mobile-navbar-links ${menuOpen ? "open" : ""}`}>
            <li><a href="#aboutus">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#fleets">Fleet</a></li>
            <li><a href="#tech">Technology</a></li>
            <li><a href="#whychooseus">Why Choose Us</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li className="mobile-navbar-book-now-mobile">
              <a
                href="https://wa.me/918484879725?text=Hi%2C%20I%20would%20like%20to%20book%20a%20service%20with%20OTONYX."
                target="_blank"
                rel="noopener noreferrer"
                className="mobile-navbar-btn"
              >
                Book Now
              </a>
            </li>
          </ul>
        </div>
      </nav>

<a
  href="https://wa.me/918484879725?text=Hi%2C%20I%20would%20like%20to%20book%20a%20service%20with%20OTONYX." // Replace with your WhatsApp number
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#25D366',
    color: 'white',
    borderRadius: '50%',
    width: '55px',
    height: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    zIndex: 999,
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  }}
  onMouseEnter={e => {
    e.currentTarget.style.transform = 'scale(1.1)';
    e.currentTarget.style.boxShadow = '0 6px 18px rgba(0, 0, 0, 0.3)';
  }}
  onMouseLeave={e => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
  }}
>
  <FaWhatsapp size={32} />
</a>



<section className="hero">
  <img src="/Cars.jpeg" alt="Corporate commute car" className="hero-image" />

  <div className="hero-overlay">
    <div className="hero-upper">
      <div className="hero-left">
        <h1>Your Trusted Partner in Managing Corporate Commute</h1>
        <p>We offer corporate car rental and employee transportation services.</p>
        <div className="button-row">
      <a href="#fleet" className="btn-primary">Explore Fleet</a>
      <a
  href="https://wa.me/918484879725?text=Hi%2C%20I%20would%20like%20to%20book%20a%20service%20with%20OTONYX."
  target="_blank"
  rel="noopener noreferrer"
  className="btn-secondary"
>
     Contact Us
</a>

    </div>
      </div>

      <div className="hero-right">
  <img src="/Hero_Info.png" alt="Your alt text here" className="hero-images" />
</div>

    </div>

    <div className="hero-lower">
      <div className="service-box-section">
        <div className="service-box">
          <h3>Corporate Car Rentals</h3>
         
        </div>
        <div className="service-box">
          <h3>Long Term - Monthly Car Rentals</h3>
          
        </div>
        <div className="service-box">
          <h3>Employee Transportation</h3>
       
        </div>
        <div className="service-box">
          <h3>Outstation Rentals</h3>
   
        </div>
        <div className="service-box">
          <h3>Mumbai – Pune Travel Services</h3>
          
        </div>
        <div className="service-box">
          <h3>Event Transportation</h3>
          
        </div>
        <div className="service-box">
          <h3>Electric Vehicle Transportation</h3>
        
        </div>
        <div className="service-box">
          <h3>Airport Transfers</h3>
         
        </div>
      </div>
    </div>
  </div>
</section>

<section id ="about" className="about-us-section">

  <div className="about-us-container">
      <h2 id ="aboutus" className="about-us-heading">About Us</h2> {/* Moved heading here */}
    <div className="about-us-left">
      <img src="/Illustration5.png" alt="About Otonyx Mobility Services" className="about-us-infographic" />
    </div>
    <div className="about-us-right">
      <h2>About Us</h2>
     <p>
  OTONYX Mobility Services is a premium chauffeur-driven car rental company in India, providing reliable, comfortable, and timely transportation solutions. We specialize in corporate car rentals, employee transport, intercity rides, and airport transfers across major cities.
  <br /><br />
  With a modern fleet and professionally trained drivers, OTONYX ensures every journey is smooth, safe, and punctual. Combining cutting-edge technology with customer-first values, we serve businesses, families, and individual travellers seeking hassle-free mobility. Whether it’s daily commuting, executive travel, or urgent trips, OTONYX is your trusted mobility partner in India.
</p>

     <ul className="about-us-points">
  <li><FaCheck className="tick-icon" /> <span>Delivering Delightful Client Experience</span></li>
  <li><FaCheck className="tick-icon" /> <span>Sustainable, Repeatable, and Proven Processes</span></li>
  <li><FaCheck className="tick-icon" /> <span>Industry Proven Thought Leadership</span></li>
</ul>
    </div>
  </div>
</section>

 <section className="mission-vision-section">
    <div className="mission-vision-content">

      <h2 className="mv-title">Empowering Your Success</h2>
      <h3 className="mv-subtitle">Our Mission & Vision</h3>

    <p className="mv-description">
  OTONYX Mobility Services offers premium chauffeur-driven car rentals for corporates, employees, intercity travel, and airport transfers. With a modern fleet, trained drivers, and customer-first values, we ensure every journey is smooth, safe, and punctual.
</p>


      <div className="mv-cards">
        <div className="mv-card">
          <FaEye className="mv-icon-1" />
          <h4 className="mv-card-title">Our Vision</h4>
          <p className="mv-card-text">
            To become a leading and trusted name in smart mobility by delivering
            safe, reliable, and customer-focused transport solutions that redefine
             convenience, comfort, and professionalism in every journey.
          </p>
        </div>
        <div className="mv-card">
          <FaBullseye className="mv-icon-2" />
          <h4 className="mv-card-title">Our Mission</h4>
          <p className="mv-card-text">
            To provide safe, reliable, and comfortable chauffeur-driven transportation
            solutions tailored to the needs of individuals, businesses, and institutions —
            through professional service, well-maintained vehicles, and a commitment
            to punctuality and customer satisfaction.
          </p>
        </div>
      </div>
      </div>
    </section>    

<section id="services" className="services-section">
  <div className="services-header">
    <h2>Our Services</h2>
    <p>
      At OTONYX Mobility Services, we’re redefining reliable travel with comfort,
      punctuality, and class. Whether you're catching a flight, managing a corporate
      fleet, or planning a weekend escape — we have you covered with tailor-made transport solutions.
    </p>
  </div>
  <div className="service-boxes-section">
    <div className="service-boxes">
      <FaBuilding className="service-icon" />
      <h4 className="service-box-one">Corporate Car Rentals</h4>
      <p>Flexible, comfortable, and reliable transport for your business needs.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Corporate Car Rentals")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaCalendarAlt className="service-icon" />
      <h4 className="service-box-one">Long Term / Monthly Car Rentals</h4>
      <p>Ideal for extended use with great value and convenience.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Long Term / Monthly Car Rentals")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaUsers className="service-icon" />
      <h4 className="service-box-one">Employee Transportation</h4>
      <p>Daily commute services ensuring safety, punctuality, and comfort.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Employee Transportation")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaMapMarkedAlt className="service-icon" />
      <h4 className="service-box-one">Outstation Rentals</h4>
      <p>Seamless intercity travel for your weekend or business trips.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Outstation Rentals")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaExchangeAlt className="service-icon" />
      <h4 className="service-box-one">Mumbai–Pune Travel Services</h4>
      <p>Premium point-to-point service connecting Maharashtra’s business hubs.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Mumbai–Pune Travel Services")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaRegCalendarCheck className="service-icon" />
      <h4 className="service-box-one">Event Transportation</h4>
      <p>End-to-end travel solutions for corporate and private events.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Event Transportation")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaBolt className="service-icon" />
      <h4 className="service-box-one">Electric Vehicle Transportation</h4>
      <p>Sustainable travel with our fully electric fleet for green mobility.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Electric Vehicle Transportation")}>View More</button>
    </div>
    <div className="service-boxes">
      <FaPlaneDeparture className="service-icon" />
      <h4 className="service-box-one">Airport Transfers</h4>
      <p>Timely pickups and drops to all major airports with professional drivers.</p>
      <button className="view-more-btn" onClick={() => handleViewMore("Airport Transfers")}>View More</button>
    </div>
  </div>
</section>


      {/* NEW section below: detail banner */}
      {selectedService && (
        <section className="service-detail-banner" ref={detailsRef}>
          <div className="detail-overlay">
            <div className="detail-left">
              <h2>{selectedService}</h2>
              <p>
                Learn more about our {selectedService} services, tailored to meet your unique travel needs with comfort and professionalism.
              </p>
            </div>
          <div className="detail-right">
  <h4 className="inquiry-title">Inquire About This Service</h4>
  <input
    type="text"
    placeholder="Your Name"
    value={userName}
    onChange={(e) => setUserName(e.target.value)}
    className="input-field"
  />
  <input
    type="text"
    placeholder="Location"
    value={userLocation}
    onChange={(e) => setUserLocation(e.target.value)}
    className="input-field"
  />
  <a
    href={`https://wa.me/918484879725?text=${encodeURIComponent(
      `Hi, I am ${userName}, needed ${selectedService} in ${userLocation}. Please share more details.`
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-btn"
  >
    Book on WhatsApp
  </a>
</div>


          </div>
        </section>
      )}



<section id="fleet" className="fleet-section">
  <h2>Our Fleet</h2>

  <div className="fleet-categories-container">
    <div className="fleet-categories-row">
      {fleetCategories.slice(0, 4).map((cat, index) => (
        <div
          key={index}
          className={`fleet-category ${selectedCategory === cat.category ? 'active' : ''}`}
          onClick={() => setSelectedCategory(cat.category)}
        >
          <img src={cat.image} alt={cat.category} />
          <p>{cat.category}</p>
        </div>
      ))}
    </div>

    <div className="fleet-categories-row">
      {fleetCategories.slice(4, 8).map((cat, index) => (
        <div
          key={index + 4}
          className={`fleet-category ${selectedCategory === cat.category ? 'active' : ''}`}
          onClick={() => setSelectedCategory(cat.category)}
        >
          <img src={cat.image} alt={cat.category} />
          <p>{cat.category}</p>
        </div>
      ))}
    </div>
  </div>

  {selectedCategory && (
    <div id="fle" className="fleet-details">
      {fleetCategories
        .filter(cat => cat.category === selectedCategory)
        .map((cat, idx) => (
          <div key={idx} className="fleet-category-detail">
            <img src={cat.image} alt={cat.category} className="big-category-image" />
            <p className="category-description">
              {cat.category} –{" "}
              {cat.description.split(',').map((part, i) => (
                <span key={i}>
                  {part.trim()}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
    </div>
  )}
</section>

<section id="fleets" className="mobile-fleet-section">
  <h2>Our Fleet</h2>

  <div className="mobile-fleet-slider-container">
    <button className="mobile-fleet-nav mobile-left" onClick={() => scrollLeft()}>&#8592;</button>

    <div className="mobile-fleet-slider" ref={sliderRef}>
      {fleetCategories.map((cat, index) => (
        <div
          key={index}
          className={`mobile-fleet-category ${selectedCategory === cat.category ? 'mobile-active' : ''}`}
          onClick={() => setSelectedCategory(cat.category)}
        >
          <img src={cat.image} alt={cat.category} />
          <p>{cat.category}</p>
        </div>
      ))}
    </div>

    <button className="mobile-fleet-nav mobile-right" onClick={() => scrollRight()}>&#8594;</button>
  </div>

  {selectedCategory && (
    <div className="mobile-fleet-details">
      {fleetCategories
        .filter(cat => cat.category === selectedCategory)
        .map((cat, idx) => (
          <div key={idx} className="mobile-fleet-category-detail">
            <img src={cat.image} alt={cat.category} className="mobile-big-category-image" />
            <p className="mobile-category-description">
              {cat.category} –{" "}
              {cat.description.split(',').map((part, i) => (
                <span key={i}>
                  {part.trim()}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
    </div>
  )}
</section>


<section id="tech" className="technology-section">
  <h2>TECHNOLOGY</h2>
  <p className="technology-description">
    A technology platform for automating complete travel experience starting from reservation to billing.
  </p>

  {/* 1. Reservation */}
  <div className="tech-block">
    <div className="tech-image">
      <img src="/1.png" alt="Reservation System" />
    </div>
    <div className="tech-content">
      <h3>Reservation</h3>
      <p>
        We ensure error-free duty scheduling by integrating technology-driven tools that allow us to manage every booking effectively and promptly.
      </p>
    </div>
  </div>

  {/* 2. Chauffeur App */}
  <div className="tech-block reverse">
    <div className="tech-image">
      <img src="/2.png" alt="Chauffeur App" />
    </div>
    <div className="tech-content">
      <h3>Chauffeur App</h3>
      <p>
        We perform every duty through a chauffeur app, which allows us to monitor operations without manual intervention and deliver better service. Key features include:
      </p>
      <ul>
       <div className="tech-list-columns">
    <ul>
      <li>Real-time trip updates</li>
      <li>Manage duty hours</li>
      <li>View allotted trips</li>
      <li>Reject/Accept trip</li>
      <li>Last mile navigation facility</li>
      <li>Transparent billing process</li>
      <li>Feedback facility</li>
    
    </ul>
  </div>
      </ul>
    </div>
  </div>

  {/* 3. Comprehensive Compliance */}
  <div className="tech-block">
    <div className="tech-image">
      <img src="/3.png" alt="Compliance Dashboard" />
    </div>
    <div className="tech-content">
      <h3>Comprehensive Compliance</h3>
      <p>
        Our Compliance Dashboard serves as a single window for monitoring all vehicle and driver compliance parameters. The operations team manages it seamlessly, ensuring everything is auditable.
      </p>
    </div>
  </div>

  {/* 4. Billing */}
  <div className="tech-block reverse">
    <div className="tech-image">
      <img src="/4.png" alt="Automated Billing" />
    </div>
    <div className="tech-content">
      <h3>Billing</h3>
      <p>
        Automatic bill generation based on GPS-tracked kilometers ensures complete transparency and reduces turnaround time for the entire billing process.
      </p>
    </div>
  </div>
</section>
<section className="locations-section">
  <div className="locations-map">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.5508467144823!2d73.9164108!3d18.5491885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1ee1a78ea27%3A0xf42b8314a07a2a8b!2sBramhacorp%20Business%20Park!5e0!3m2!1sen!2sin!4v1753176355756!5m2!1sen!2sin"
      width="100%"
      height="300"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Otonyx Mobility Office – Bramhacorp Business Park"
    />

    
  </div>

  <div className="locations-list">
    <h3>Our Presence</h3>
    <div className="cities">
      <span>Pune</span>
      <span>Mumbai</span>
      <span>Delhi</span>
      <span>Chennai</span>
      <span>Kolkata</span>
      <span>Bangalore</span>
      <span>Goa</span>
      <span>Kerala</span>
      <span>Maharashtra</span>
    </div>
        <div className="map-address">
          Our Office : UNIT 1829 BDL T9-A1, Brahmacorp Business Park, Vadgaon Sheri, Pune, Maharashtra, India, 411014
    </div>
  </div>
</section>




  
 
<section id="whychooseus"className="why-choose-section">
  <h2>Why OTONYX?</h2>
  <div className="why-cards">
    <div className="why-card">
      <FaMapMarkedAlt className="why-icon" />
      <h3>GPS enabled Well Maintained Fleet</h3>
      <p>Well-maintained fleet, always trackable for safety and reliability.</p>
    </div>
    <div className="why-card">
      <FaUserCheck className="why-icon" />
      <h3>Verified Chauffeurs to Experienced</h3>
      <p>Well-trained, professional drivers for your safety and comfort.</p>
    </div>
    <div className="why-card">
      <FiHeadphones className="why-icon" />
      <h3>24/7 Support</h3>
      <p>Round-the-clock assistance & flexible booking options.</p>
    </div>
 
    <div className="why-card">
      <FaCogs className="why-icon" />
      <h3>Tailored Solutions</h3>
      <p>Customized travel plans for every unique requirement.</p>
    </div>
    <div className="why-card">
      <FaSprayCan className="why-icon" />
      <h3>Clean & Sanitized</h3>
      <p>Air-conditioned, sanitized vehicles for every ride.</p>
    </div>
       <div className="why-card">
      <FaHandshake className="why-icon" />
      <h3>Corporate Partnerships</h3>
      <p>Custom solutions for corporate & hotel requirements.</p>
    </div>
    <div className="why-card">
  <FaMobileAlt className="why-icon" />
  <h3>App-Driven Bookings</h3>
  <p>Every duty is managed via a reliable app to ease the customer experience.</p>
</div>
<div className="why-card">
  <FaShieldAlt className="why-icon" />
  <h3>Safe Travel Experience</h3>
  <p>Specially trained chauffeurs to ensure women traveler safety at all times.</p>
</div>

  </div>
</section>

 <section id="testimonials" className="testimonials-section">
      <h2 className="testimonials-title">What Our Customers Say</h2>

      <div className="testimonial-controls">
        <button onClick={handlePrev} className="arrow-btn">‹</button>

        <div className="testimonial-cards">
          {Array.from({ length: cardsPerPage }).map((_, idx) => {
            const testimonial =
              testimonials[(startIndex + idx) % testimonials.length];
            return (
              <div className="testimonial-card" key={idx}>
                <div className="testimonial-header">
                  <div className="testimonial-name">{testimonial.name}</div>
                  <div className="testimonial-stars">
                    {"⭐".repeat(testimonial.stars)}
                  </div>
                </div>
                <p className="testimonial-text">{testimonial.text}</p>
              </div>
            );
          })}
        </div>

        <button onClick={handleNext} className="arrow-btn">›</button>
      </div>
    </section>


<section className="founder-section">
  <div className="founder-image">
    <img src="/Founder.png" alt="Joseph Philip - Founder of Otonyx Mobility Services" />
  </div>
  <div className="founder-text">
    <h3>About the Founder</h3>
    <p>
      Joseph Philip, the visionary behind OTONYX , brings over 25 years of expertise in the automobile industry.
      A seasoned professional and exceptional leader, Joseph has successfully led teams, streamlined large-scale operations, and built a reputation for integrity, precision, and service excellence.
      Driven by his passion to redefine urban and intercity mobility, he remains committed to delivering safe, seamless, and superior travel experiences.
      His leadership forms the backbone of OTONYX's promise: where comfort meets commitment.
    </p>
  </div>
</section>


<footer id="contactus" className="footer">
  <div className="footer-overlay">
    <div className="footer-container">
      <div className="footer-left">
        <img src="/Logo1.png" alt="Otonyx Logo" className="footer-logo" />
        <p className="footer-description">
          OTONYX Mobility Services is a premium chauffeur-driven car rental company, delivering reliable and comfortable transport solutions across India.
        </p>
      </div>

      <div id="contact" className="footer-column">
        <h4>Quick Links</h4>
        <ul>
          <li><a href="#about">About Us</a></li>
          <li><a href="#fleet">Fleet</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#whychooseus">Why Choose Us</a></li>
          <li><a href="#testimonials">Testimonials</a></li>
        </ul>
      </div>

      <div className="footer-column">
        <h4>Our Services</h4>
        <ul>
          <li>Corporate Car Rentals</li>
          <li>Long Term / Monthly Car Rentals</li>
          <li>Employee Transportation</li>
          <li>Outstation Rentals</li>
          <li>Mumbai – Pune Travel Services</li>
          <li>Event Transportation</li>
          <li>Electric Vehicle Transportation</li>
          <li>Airport Transfers</li>
        </ul>
      </div>

      <div className="footer-column">
        <h4>Contact Us</h4>
        <p>📞 +91 8484 8797 25</p>
        <p>📧 info@otonyxindia.com</p>
        <p>UNIT 1829 BDL T9-A1, Brahmacorp Business Park, Vadgaon Sheri, Pune, Maharashtra, India, 411014</p>
          <div className="social-icons">

    <a href="https://www.instagram.com/otonyx_mobility?igsh=NnV6MTA2aDF6cmRv" target="_blank" rel="noopener noreferrer">
      <FaInstagram />
    </a>
    <a href="https://www.linkedin.com/in/joseph-philip-557914335?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer">
      <FaLinkedinIn />
    </a>
  </div>
        <a
          href="https://wa.me/918484879725?text=Hi%2C%20I%20would%20like%20to%20book%20a%20service%20with%20OTONYX."
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          Chat on WhatsApp
        </a>
      </div>
    </div>
    <div className="footer-bottom">
      &copy; 2025 OTONYX Mobility Services. All rights reserved.
    </div>
  </div>
</footer>



    </div>
  );
};

export default LandingPage;
